import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { routeNames } from '@/router';
import { getIssueAttachment } from '@/features/Issues/services/api';
import { convertFilesToAttachments, downloadFile } from '../../helpers';
import { useReCaptcha } from 'vue-recaptcha-v3-esm';

export const useFormData = <T extends object>(initialData: T = {} as T, initRecaptcha: boolean = true) => {
    const router = useRouter();
    const recaptcha = useReCaptcha();
    const initialFormState = { ...initialData };
    const formData = ref<T>(initialFormState);
    const files = ref<(File & { content: number[] })[]>([]);

    const mappedFileAttachments = (file?: (File & { content: number[] })[]) => convertFilesToAttachments(file || files.value);

    const loadRecaptcha = async () => {
        if (recaptcha && !recaptcha.isLoaded) {
            await recaptcha.recaptchaLoaded();
        }
    };

    const executeRecaptcha = async (action: string): Promise<string> => {
        if (!recaptcha) return '';
        return recaptcha.executeRecaptcha(action);
    };

    const resetFormData = (formRef: any) => {
        formData.value = { ...initialData };
        files.value = [];
        if (formRef.value) {
            formRef.value.resetValidation();
        }
    };

    const redirectToDetails = (id: string | number | undefined) => id && router.push({ name: routeNames.issueDetails, params: { id } });

    const downloadAttachment = async (issueId: number, attachmentId: string, fileName: string): Promise<boolean> => {
        try {
            const res = await getIssueAttachment(issueId, attachmentId);
            if (!res?.ok) return false;

            const blob = await res.blob();
            downloadFile(blob, fileName);
            return true;
        } catch {
            return false;
        }
    };

    if (initRecaptcha) {
        onMounted(loadRecaptcha);
    }

    return {
        formData,
        files,
        mappedFileAttachments,
        downloadAttachment,
        executeRecaptcha,
        resetFormData,
        redirectToDetails
    };
};
